import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getHistory = (state) =>
    resolveProp('history', state) || {
        routes: [],
        previous: '',
    };

export default createSelector(getHistory, (history) => history);
